import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, useFragment } from 'react-relay';

import styles from './PdpSharedSellerInfo.scss';
import classNames from 'classnames';

import { type PdpSharedSellerAssociations_seller$key } from './__generated__/PdpSharedSellerAssociations_seller.graphql';

const sellerFragment = graphql`
    fragment PdpSharedSellerAssociations_seller on Seller {
        tradeAssociations {
            serviceId
            displayName
        }
    }
`;

export const PdpSharedSellerAssociations: FC<{
    seller: PdpSharedSellerAssociations_seller$key;
    isCompact?: boolean;
}> = ({ seller: sellerRef, isCompact = false }) => {
    const seller = useFragment(sellerFragment, sellerRef);
    const tradeAssociations = seller?.tradeAssociations;

    if (!tradeAssociations || !tradeAssociations.length) {
        return null;
    }

    return (
        <div
            className={classNames(styles.associations, { [styles.compact]: isCompact })}
            data-tn="dealer-associations"
        >
            <FormattedMessage id="PdpSharedSellerInfo.associations" defaultMessage="Associations" />

            <div className={styles.associationsList}>
                {tradeAssociations.map(association => {
                    const { displayName, serviceId } = association || {};

                    if (!displayName || !serviceId) {
                        return null;
                    }

                    return (
                        <span key={serviceId} className={styles.info}>
                            {displayName}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};
